if (!customElements.get('sample-product-card')) {
  customElements.define(
    'sample-product-card',
    class SampleProductCard extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('.sample-product-card__form');
        this.button = this.querySelector('.sample-product-card__button');
        this.variantId = this.querySelector('[name="id"]')?.value || this.dataset.variantId;
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.helpButton = this.querySelector('.sample-product-card__help-button');
        this.helpPopover = this.querySelector('.sample-product-card__help-popover');
        this.onDocumentClick = this.closeHelpPopover.bind(this);

        if (this.form && this.button && this.variantId) {
          this.form.addEventListener('submit', this.onAddSample.bind(this));
        }

        if (this.helpButton && this.helpPopover) {
          this.helpButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.helpPopover.classList.toggle('hidden');
          });

          document.addEventListener('click', this.onDocumentClick);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      closeHelpPopover() {
        if (this.helpPopover) this.helpPopover.classList.add('hidden');
      }

      getSectionsToRender() {
        if (this.cart?.getSectionsToRender) return this.cart.getSectionsToRender();

        return [
          { id: 'cart-drawer' },
          { id: 'cart-icon-bubble' },
        ];
      }

      getSectionIds() {
        return this.getSectionsToRender().map((section) => section.id);
      }

      buildFormData() {
        const formData = new FormData(this.form);
        const sectionIds = this.getSectionIds();

        if (sectionIds.length > 0) {
          formData.set('sections', sectionIds.join(','));
          formData.set('sections_url', window.location.pathname);
        }

        return formData;
      }

      setLoading(isLoading) {
        const spinner = this.button?.querySelector('.loading__spinner');

        if (isLoading) {
          this.button?.classList.add('loading');
          this.button?.setAttribute('aria-disabled', 'true');
          if (spinner) spinner.classList.remove('hidden');
          return;
        }

        this.button?.classList.remove('loading');
        this.button?.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      }

      async fetchCartSections() {
        const sectionIds = this.getSectionIds();
        if (sectionIds.length === 0) return null;

        const sectionsUrl = `${window.location.pathname}?sections=${sectionIds.join(',')}`;
        const response = await fetch(sectionsUrl, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) return null;

        return response.json();
      }

      async renderCart(addResponse) {
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.cart.classList.remove('is-empty');

        try {
          if (this.cart.setActiveElement) this.cart.setActiveElement(document.activeElement);
          if (addResponse.sections && this.cart.renderContents) {
            this.cart.renderContents(addResponse);
            return;
          }
        } catch (error) {
          console.warn('Sample cart render failed. Trying section fallback.', error);
        }

        try {
          const sections = await this.fetchCartSections();
          if (sections && this.cart.renderContents) {
            this.cart.renderContents({
              ...addResponse,
              sections,
            });
            return;
          }
        } catch (error) {
          console.warn('Sample cart section fallback failed.', error);
        }

        window.location = window.routes.cart_url;
      }

      async onAddSample(event) {
        event.preventDefault();
        if (this.button?.classList.contains('loading')) return;

        this.setLoading(true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = this.buildFormData();

        try {
          const response = await fetch(window.routes.cart_add_url, config);
          const parsedState = await response.json();

          if (parsedState.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'sample-product-card',
              productVariantId: this.variantId,
              errors: parsedState.errors || parsedState.description,
              message: parsedState.message,
            });
            console.error('Error adding sample:', parsedState.description || parsedState.message);
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sample-product-card',
            productVariantId: this.variantId,
            cartData: parsedState,
          });

          await this.renderCart(parsedState);
        } catch (error) {
          console.error('Fetch error adding sample:', error);
          window.location = window.routes.cart_url;
        } finally {
          this.setLoading(false);
        }
      }
    }
  );
}
